// @ts-nocheck
import { HasOnComplete } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    submitSimpleQuoteForm,
    SubmitSimpleQuoteFormApiParameter,
    SubmitSimpleQuoteFormModel,
} from "@store/Framework/Services/SimpleQuoteService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type ApiResult = SubmitSimpleQuoteFormModel;
type ApiParameter = SubmitSimpleQuoteFormApiParameter;
type Parameter = ApiParameter & HasOnSuccess<ApiResult> & HasOnError<string> & HasOnComplete<void>;

type HandlerType = ApiHandlerDiscreteParameter<Parameter, ApiParameter, ServiceResult<ApiResult>>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, onComplete, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await submitSimpleQuoteForm(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const ExecuteOnCompleteCallback: HandlerType = props => {
    props.parameter.onComplete?.();
};

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
    ExecuteOnCompleteCallback,
];

const submitForm = createHandlerChainRunner(chain, "SubmitForm");
export default submitForm;
